<template>
  <div>
    <template v-if="!loading">
      <div class="confetti" v-if="!isCongratulation">
        <div v-if="isPass">
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
          <div class="confetti-piece"></div>
        </div>
        <div>
          <div class="modal-header">
            <img v-if="!mobile && !isWrong" style="width:60px;padding: 5px"
              :src="isPass ? isWrong ? iconPass : iconFullMark : iconFail" alt="">
            <h1 :class="isPass ? 'titlePass' : 'titleFail'">{{ isPass ? isWrong ? $t('manage_student.lesson_pass') :
                $t('manage_student.lesson_tuyet_doi') : $t('manage_student.lesson_unpass')
            }}</h1>
            <img v-if="!mobile" style="width:60px;padding: 5px"
              :src="isPass ? isWrong ? iconPass : iconFullMark : iconFail" alt="">
          </div>
          <img class="modal-icon u-imgResponsive" :src="isPass ? isWrong ? avaPass : avaFullMark : avaFail" />
          <div class="modal-subheader">{{ $t('new.title122') }}: <span>{{ recentScore }} / {{ maxScore }}</span></div>
          <div class="modal-bottom">
            <button @click="goToListWrong()" class="btn-hover color-9 u-btn--share" :class="{ lkt_enable: isWrong }">{{
                $t('new.title123')
            }}</button>
            <button @click="back()" class="btn-hover color-5 lkt_enable">{{ $t('new.title124') }}<img
                src="/static/images/congratulation/quality.png" alt=""></button>
          </div>
        </div>
      </div>
      <div class="confetti" v-else>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div>
          <div class="modal-header">
            <h1 class="titleNoti">{{ $t('new.title86') }}</h1>
          </div>
          <img class="modal-icon u-imgResponsive" src="/static/images/congratulation/img_waiting.png" />
          <div class="modal-subheader">{{ $t('new.title125') }}</div>
          <div class="modal-bottom">
            <button @click="back()" class="btn-hover color-5 lkt_enable">{{ $t('new.title124') }}<img
                src="/static/images/congratulation/quality.png" alt=""></button>
          </div>
        </div>
      </div>
    </template>

    <!-- Loading -->
    <loading :showLoading="loading" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import loading from "@/components/loading/loading";

export default {
  data() {
    return {
      outlineInfo: eval("(" + this.$route.query.outlineInfo + ")"),
      maxScore: 0,
      recentScore: 0,
      passMarks: 0,
      isPass: false,
      avaPass: "/static/images/congratulation/img_pass.png",
      avaFullMark: "/static/images/congratulation/img_fullMark.png",
      avaFail: "/static/images/congratulation/img_fail.png",
      iconPass: "/static/images/congratulation/icon_pass.png",
      iconFullMark: "/static/images/congratulation/icon_fullMark.png",
      iconFail: "/static/images/congratulation/icon_fail.png",
      isWrong: false,
      isCongratulation: false,
      loading: true
    };
  },
  components: {
    loading,
  },
  computed: {
    // Lấy dữ liệu từ store
    ...mapState({
      mobile: (state) => state.header.mobile,
    }),
  },
  async created() {
    await this.init();
    this.loading = false;
  },
  mounted() { },
  methods: {
    async init() {
      this.isCongratulation = this.outlineInfo.isCongratulation;
      let result = await this.getDataInfoExam();
      let listWrong = await this.checkStatusExam();
      this.maxScore = result.fullMarks;
      this.recentScore = result.recentScore;
      this.passMarks = parseFloat(result.passMarks);
      this.recentScore >= this.passMarks ? this.isPass = true : this.isPass;
      listWrong.length > 0 ? this.isWrong = true : this.isWrong;
    },
    // Trở lại mục lục
    back() {
      if (this.$route.query.isCurriculumExam) {
        this.$router.push({
          path: "/home/curriculumExam",
          query: {
            outlineInfo: JSON.stringify({
              courseId: this.outlineInfo.courseId,
              courseName: this.outlineInfo.courseName,
            }),
          },
        });
      } else {
        this.$router.push({
          path: "/home/curriculum",
          query: {
            outlineInfo: JSON.stringify({
              courseId: this.outlineInfo.courseId,
              courseName: this.outlineInfo.courseName,
            }),
          },
        });
      }
      // location.reload();
    },
    // Lấy thông tin điểm của bài thi
    async getDataInfoExam() {
      return new Promise((resolve, reject) => {
        this.$api
          .post("/studyCourseQuestion/getPastExamInfo", {
            courseId: this.outlineInfo.courseId,
            examId: this.outlineInfo.examId,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    // Kiểm tra danh sách câu trả lời sai
    async checkStatusExam() {
      return new Promise((resolve, reject) => {
        this.$api
          .post("/studyCourseQuestion/getWrongBook", {
            languageType: this.$lang(),
            courseId: this.outlineInfo.courseId,
            examId: this.outlineInfo.examId,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    // Đến trang danh sách câu trả lời sai
    goToListWrong() {
      if (this.$route.query.isCurriculumExam) {
        this.$router.push({
          path: "/home/exam/wrongbook",
          query: {
            courseId: this.outlineInfo.courseId,
            examId: this.outlineInfo.examId,
            courseName: this.outlineInfo.courseName,
            examFlag: this.$route.query.examFlag,
            isCurriculumExam: true,
            examName: this.outlineInfo.examName
          }
        });
      } else {
        this.$router.push({
          path: "/home/exam/wrongbook",
          query: {
            courseId: this.outlineInfo.courseId,
            examId: this.outlineInfo.examId,
            courseName: this.outlineInfo.courseName,
            examFlag: this.$route.query.examFlag,
            examName: this.outlineInfo.examName
          }
        });
      }

    },
  },
};
</script>

<style scoped>
body {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.lkt_enable {
  display: flex !important;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.u-btn--share {
  display: none;
}

.titlePass {
  color: #309830;
  text-transform: capitalize;
}

.titleFail {
  color: #93122a;
  text-transform: capitalize;
}

.titleNoti {
  color: #0071c5;
  text-transform: capitalize;
}

.btn-hover {
  width: 200px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  margin: 20px;
  height: 55px;
  text-align: center;
  border: none;
  background-size: 300% 100%;

  border-radius: 50px;
  moz-transition: all .4s ease-in-out;
  -o-transition: all .4s ease-in-out;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
}

.btn-hover:hover {
  background-position: 100% 0;
  moz-transition: all .4s ease-in-out;
  -o-transition: all .4s ease-in-out;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
}

.btn-hover:focus {
  outline: none;
}

.btn-hover.color-5 {
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
}

.btn-hover.color-9 {
  background-image: linear-gradient(to right, #25aae1, #4481eb, #04befe, #3f86ed);
  box-shadow: 0 4px 15px 0 rgba(65, 132, 234, 0.75);
}

.modal-bottom {
  display: flex;
  flex-wrap: wrap;
  padding: 15px 55px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background: #fff;
  justify-content: center;
}

/*.modal-btn:nth-of-type(2) {*/
/*  margin-left: 30px;*/
/*}*/

.modal-btn {
  margin: 10px auto;
}

.u-btn {
  flex: 0 0 100%;
  padding: 14px 20px;
  border: 0;
  background: linear-gradient(to top, rgba(255, 255, 255, 0) 0%, rgba(250, 198, 100, 0.27) 100%), #2976df;
  border-radius: 25px;
  color: #fff;
  font-size: 18px;
  letter-spacing: 1px;
  transition: all 0.2s ease;
  box-shadow: 0 15px 40px 0 rgba(41, 118, 223, 0.5);
}

.u-btn:hover {
  opacity: 0.9;
}

.u-btn.u-btn--success {
  background: #00d000;
  box-shadow: 0 15px 40px 0 rgba(0, 208, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.modal-icon {
  display: block;
  max-width: 207px;
  margin: 30px auto 30px;
}

.modal-header {
  margin-bottom: 10px;
  font-size: 25.5px;
  letter-spacing: 2px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-subheader {
  max-width: 520px;
  margin: 0 auto;
  font-size: 20px;
  line-height: 1.3;
  letter-spacing: 1.25px;
  text-align: center;
  color: #999;
}

.modal-subheader span {
  color: #0071c5;
}

.icon {
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 32px;
  position: relative;
}

.confetti {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.confetti-piece {
  position: absolute;
  width: 8px;
  height: 16px;
  background: #ffd300;
  top: 0;
  opacity: 0;
}

.confetti-piece:nth-child(1) {
  left: 7%;
  transform: rotate(46deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2400ms;
  animation-delay: 2400ms;
  -webkit-animation-duration: 3012ms;
  animation-duration: 3012ms;
}

.confetti-piece:nth-child(2) {
  left: 14%;
  transform: rotate(-37deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2487ms;
  animation-delay: 2487ms;
  -webkit-animation-duration: 3119ms;
  animation-duration: 3119ms;
}

.confetti-piece:nth-child(3) {
  left: 21%;
  transform: rotate(76deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2124ms;
  animation-delay: 2124ms;
  -webkit-animation-duration: 2810ms;
  animation-duration: 2810ms;
}

.confetti-piece:nth-child(4) {
  left: 28%;
  transform: rotate(-79deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2476ms;
  animation-delay: 2476ms;
  -webkit-animation-duration: 2942ms;
  animation-duration: 2942ms;
}

.confetti-piece:nth-child(5) {
  left: 35%;
  transform: rotate(-4deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2470ms;
  animation-delay: 2470ms;
  -webkit-animation-duration: 2941ms;
  animation-duration: 2941ms;
}

.confetti-piece:nth-child(6) {
  left: 42%;
  transform: rotate(42deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2183ms;
  animation-delay: 2183ms;
  -webkit-animation-duration: 3029ms;
  animation-duration: 3029ms;
}

.confetti-piece:nth-child(7) {
  left: 49%;
  transform: rotate(-15deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2423ms;
  animation-delay: 2423ms;
  -webkit-animation-duration: 2989ms;
  animation-duration: 2989ms;
}

.confetti-piece:nth-child(8) {
  left: 56%;
  transform: rotate(-28deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2107ms;
  animation-delay: 2107ms;
  -webkit-animation-duration: 2918ms;
  animation-duration: 2918ms;
}

.confetti-piece:nth-child(9) {
  left: 63%;
  transform: rotate(-34deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2092ms;
  animation-delay: 2092ms;
  -webkit-animation-duration: 2956ms;
  animation-duration: 2956ms;
}

.confetti-piece:nth-child(10) {
  left: 70%;
  transform: rotate(44deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2030ms;
  animation-delay: 2030ms;
  -webkit-animation-duration: 3139ms;
  animation-duration: 3139ms;
}

.confetti-piece:nth-child(11) {
  left: 77%;
  transform: rotate(70deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2145ms;
  animation-delay: 2145ms;
  -webkit-animation-duration: 2980ms;
  animation-duration: 2980ms;
}

.confetti-piece:nth-child(12) {
  left: 84%;
  transform: rotate(69deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2018ms;
  animation-delay: 2018ms;
  -webkit-animation-duration: 2786ms;
  animation-duration: 2786ms;
}

.confetti-piece:nth-child(13) {
  left: 91%;
  transform: rotate(-1deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 2099ms;
  animation-delay: 2099ms;
  -webkit-animation-duration: 2798ms;
  animation-duration: 2798ms;
}

.confetti-piece:nth-child(odd) {
  background: #17d3ff;
}

.confetti-piece:nth-child(even) {
  z-index: 1;
}

.confetti-piece:nth-child(4n) {
  width: 5px;
  height: 12px;
  -webkit-animation-duration: 4000ms;
  animation-duration: 4000ms;
}

.confetti-piece:nth-child(3n) {
  width: 3px;
  height: 10px;
  -webkit-animation-duration: 4500ms;
  animation-duration: 4500ms;
  -webkit-animation-delay: 3000ms;
  animation-delay: 3000ms;
}

.confetti-piece:nth-child(4n-7) {
  background: #ff4e91;
}

@-webkit-keyframes makeItRain {
  from {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  to {
    transform: translateY(100vh);
  }
}

@keyframes makeItRain {
  from {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  to {
    transform: translateY(100vh);
  }
}

/* media query */

@media (max-width: 480px) {
  .btn-hover {
    margin: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/congratulations/congratulation.vue